import React, { useState } from 'react'
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from '@/Components/ui/sheet'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import MultipleSelector from '@/Components/Common/MultipleSelector'
import { cn } from '@/lib/utils'
import { Calendar } from '@/Components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { Button } from '@/Components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/Components/ui/card'
import { Input } from '@/Components/ui/input'
import { Label } from '@/Components/ui/label'
import { FilterIcon, SquarePlus, CalendarIcon, CircleX } from 'lucide-react'

import { format } from 'date-fns'
import Constant from '@/utils/Constant'
import { useLoaderData } from 'react-router-dom'
import DatePicker from '@/Components/Common/DatePicker'
import { current } from '@reduxjs/toolkit'
import WorkAllocationFilterField from './WorkAllocationFilterField'

const WorkAllocationFilter = ({
    chartStatusData,
    assessmentTypeData,
    payorTypeData,
    followupStatus,
    chartLockIssue,
    currentTab,
    event,
    updateEvent,
    coder,
    qa,
    qa_tl,
    prod_tl,
}) => {
    const allowedfield = WorkAllocationFilterField(currentTab)

    const [agency, setAgency] = useState()

    const priorities = [
        { name: 'High', priority: 'High' },
        { name: 'NA', priority: ' ' },
    ]
    const [sheetIsOpen, setSheetIsOpen] = useState(false)
    return (
        <>
            {sheetIsOpen && <div className="fixed inset-0 bg-black/50 z-40" />}
            <Sheet open={sheetIsOpen} onOpenChange={setSheetIsOpen} modal={false}>
                <SheetTrigger asChild>
                    <Button variant="outline" className="mb-0  bg-green-500 text-white hover:bg-green-600 hover:text-white">
                        <FilterIcon size={20} />
                    </Button>
                </SheetTrigger>
                <SheetContent>
                    <SheetHeader>
                        <SheetTitle>Apply Filters</SheetTitle>
                    </SheetHeader>
                    <div className="grid gap-4 py-4">
                        <div className="grid grid-cols-2 items-center gap-4">
                            {allowedfield.includes('Agency') && (
                                <SearchableDropdown
                                    options={[{ agency: 'Bayada' }]}
                                    placeholder="Agency"
                                    label="agency"
                                    selectedVal={agency}
                                    handleChange={(val) => {
                                        setAgency(() => val)
                                    }}
                                />
                            )}

                            {allowedfield.includes('MR Number') && (
                                <Input
                                    placeholder="MR Number"
                                    onChange={(e) => updateEvent({ searchFilter: { ...event.searchFilter, mr_number: e.target.value } })}
                                />
                            )}
                        </div>
                        <div className="grid grid-cols-1 items-center gap-4">
                            {allowedfield.includes('Payor Type') && (
                                <MultipleSelector
                                    placeHolder="Payor Type"
                                    selectedValue={event.searchFilter.payor_type}
                                    label="name"
                                    onChange={(newPayor) => {
                                        if (Array.isArray(newPayor)) {
                                            updateEvent({
                                                searchFilter: {
                                                    ...event.searchFilter,
                                                    payor_type: newPayor,
                                                },
                                            })
                                            return [...newPayor]
                                        }
                                    }}
                                    items={
                                        event.searchFilter.payor_type.length == 0
                                            ? payorTypeData
                                            : payorTypeData.filter((item) => !event.searchFilter.payor_type.includes(item.payor_type))
                                    }
                                />
                            )}
                        </div>
                        <div className="grid grid-cols-1 items-center gap-4">
                            {allowedfield.includes('Assessment Type') && (
                                <MultipleSelector
                                    placeHolder="Assessment Type"
                                    items={
                                        event.searchFilter.assessment_type.length == 0
                                            ? assessmentTypeData
                                            : assessmentTypeData.filter((item) => !event.searchFilter.assessment_type.includes(item.assessment_type))
                                    }
                                    selectedValue={event.searchFilter.assessment_type}
                                    label="name"
                                    onChange={(newAssessment) => {
                                        if (Array.isArray(newAssessment)) {
                                            updateEvent({
                                                searchFilter: {
                                                    ...event.searchFilter,
                                                    assessment_type: newAssessment,
                                                },
                                            })
                                            return [...newAssessment]
                                        }
                                    }}
                                    // getItemLabel={(item) => item.name}
                                />
                            )}
                        </div>
                        <div className="grid grid-cols-2 items-center gap-4">
                            {allowedfield.includes('Patient Name') && (
                                <Input
                                    placeholder="Patient Name"
                                    onChange={(e) => updateEvent({ searchFilter: { ...event.searchFilter, patient_name: e.target.value } })}
                                />
                            )}

                            {allowedfield.includes('Coder Name') && (
                                <SearchableDropdown
                                    options={coder}
                                    placeholder="Coder Name"
                                    selectedVal={event.searchFilter.coder_name?.full_name}
                                    handleChange={(val) => {
                                        updateEvent({ searchFilter: { ...event.searchFilter, coder_name: val } })
                                        return val
                                    }}
                                    label="name"
                                    type="GET_OBJ"
                                />
                            )}
                        </div>
                        {allowedfield.includes('Chart Status') && (
                            <MultipleSelector
                                placeHolder="Chart Status"
                                selectedValue={event.searchFilter.chart_status}
                                label="chart_status"
                                onChange={(newChartStatus) => {
                                    if (Array.isArray(newChartStatus)) {
                                        updateEvent({
                                            searchFilter: {
                                                ...event.searchFilter,
                                                chart_status: newChartStatus,
                                            },
                                        })
                                        return [...newChartStatus] // Concatenate objects if array
                                    }
                                }}
                                items={
                                    event.searchFilter.chart_status.length == 0
                                        ? chartStatusData
                                        : chartStatusData.filter((item) => !event.searchFilter.chart_status.includes(item.chart_status))
                                }
                            />
                        )}
                        <div className="grid grid-cols-2 items-center gap-4">
                            {allowedfield.includes('QA Name') && (
                                <SearchableDropdown
                                    options={qa}
                                    placeholder="QA Name"
                                    selectedVal={event.searchFilter.qa_name?.full_name}
                                    handleChange={(val) => {
                                        updateEvent({ searchFilter: { ...event.searchFilter, qa_name: val } })
                                        return val
                                    }}
                                    label="name"
                                    type="GET_OBJ"
                                />
                            )}
                            {allowedfield.includes('Prod TL') && (
                                <SearchableDropdown
                                    options={prod_tl}
                                    placeholder="Prod TL"
                                    selectedVal={event.searchFilter.prod_tl?.full_name}
                                    handleChange={(val) => {
                                        updateEvent({ searchFilter: { ...event.searchFilter, prod_tl: val } })
                                        return val
                                    }}
                                    label="name"
                                    type="GET_OBJ"
                                />
                            )}
                            {allowedfield.includes('QA TL') && (
                                <SearchableDropdown
                                    options={qa_tl}
                                    selectedVal={event.searchFilter.qa_tl?.full_name}
                                    handleChange={(val) => {
                                        updateEvent({ searchFilter: { ...event.searchFilter, qa_tl: val } })
                                        return val
                                    }}
                                    placeholder="QA TL"
                                    type="GET_OBJ"
                                />
                            )}
                            {allowedfield.includes('Priority') && (
                                <SearchableDropdown
                                    options={priorities}
                                    selectedVal={event.searchFilter.priority}
                                    handleChange={(val) => {
                                        updateEvent({ searchFilter: { ...event.searchFilter, priority: val } })
                                        return val
                                    }}
                                    placeholder="Select Priority"
                                    label="priority"
                                />
                            )}
                        </div>
                        <div className="grid grid-cols-2 items-center gap-4">
                            {allowedfield.includes('Chart Lock User') && <SearchableDropdown options={[]} placeholder="Chart Lock User" />}
                            {allowedfield.includes('Chart Lock Issue') && (
                                <SearchableDropdown
                                    options={chartLockIssue}
                                    selectedVal={event.searchFilter.chart_lock_issue}
                                    handleChange={(val) => {
                                        updateEvent({ searchFilter: { ...event.searchFilter, chart_lock_issue: val } })
                                    }}
                                    label="chart_lock_issue"
                                    placeholder="Chart Lock Issue"
                                />
                            )}
                            {allowedfield.includes('Coding Level Appeal') && (
                                <SearchableDropdown
                                    options={[{ name: 'Coding 1st Level Appeal' }, { name: 'Conding 2nd Level Appeal' }]}
                                    placeholder="Coding Level Appeal"
                                    selectedVal={event.searchFilter.coding_level_appeal}
                                    handleChange={(val) => {
                                        updateEvent({ searchFilter: { ...event.searchFilter, coding_level_appeal: val } })
                                    }}
                                    label="name"
                                />
                            )}
                            {allowedfield.includes('Follow Up Status') && (
                                <SearchableDropdown
                                    options={followupStatus}
                                    label="name"
                                    selectedVal={event.searchFilter.follow_up_status}
                                    handleChange={(val) => {
                                        setFollowupStatus(() => {
                                            updateEvent({ searchFilter: { ...event.searchFilter, follow_up_status: val } })
                                            return val
                                        })
                                    }}
                                    placeholder="Followup Status"
                                />
                            )}
                        </div>
                        {console.log('event.searchFilter :> ')}
                        <div className="grid grid-cols-1 items-center gap-4">
                            {allowedfield.includes('Follow Up Date Range') && (
                                <DatePicker
                                    mode="range"
                                    defaultMonth={event.searchFilter.follow_up_date?.from}
                                    selected={event.searchFilter.follow_up_date}
                                    handleChange={(currentDate) => {
                                        updateEvent({
                                            searchFilter: {
                                                ...event.searchFilter,
                                                follow_up_date: currentDate,
                                            },
                                        })
                                    }}
                                    date={event.searchFilter.follow_up_date}
                                    placeHolder="Follow Up Date Range"
                                />
                            )}
                            {allowedfield.includes('Audit Date Range') && (
                                <DatePicker
                                    mode="range"
                                    defaultMonth={event.searchFilter.qa_chart_assign_date?.from}
                                    selected={event.searchFilter.qa_chart_assign_date}
                                    handleChange={(auditDate) => {
                                        updateEvent({
                                            searchFilter: {
                                                ...event.searchFilter,
                                                qa_chart_assign_date: auditDate,
                                            },
                                        })
                                    }}
                                    date={event.searchFilter.qa_chart_assign_date}
                                    placeHolder="Audit Date Range"
                                />
                            )}
                            {allowedfield.includes('Review Date Range') && (
                                <DatePicker
                                    mode="range"
                                    defaultMonth={event.searchFilter.coder_chart_assign_date?.from}
                                    selected={event.searchFilter.coder_chart_assign_date}
                                    handleChange={(reviewDate) => {
                                        updateEvent({
                                            searchFilter: {
                                                ...event.searchFilter,
                                                coder_chart_assign_date: reviewDate,
                                            },
                                        })
                                    }}
                                    date={event.searchFilter.coder_chart_assign_date}
                                    placeHolder="Review Date Range"
                                />
                            )}
                            {allowedfield.includes('Chart Lock Date Range') && (
                                <DatePicker
                                    mode="range"
                                    defaultMonth={event.searchFilter.chart_lock?.from}
                                    selected={event.searchFilter.chart_lock}
                                    handleChange={(currentDate) => {
                                        updateEvent({
                                            searchFilter: {
                                                ...event.searchFilter,
                                                chart_lock: currentDate,
                                            },
                                        })
                                    }}
                                    date={event.searchFilter.chart_lock}
                                    placeHolder="Chart Lock Date Range"
                                />
                            )}
                        </div>
                    </div>
                </SheetContent>
            </Sheet>
        </>
    )
}

export default WorkAllocationFilter
